/** True after the visitor confirms a Google Classroom share at least once. */
export const CLASSROOM_SHARE_CONFIRMED_KEY = "playmath.hasSharedToGoogleClassroom";

export function hasConfirmedClassroomShare(): boolean {
  try {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(CLASSROOM_SHARE_CONFIRMED_KEY) === "1";
  } catch {
    return false;
  }
}

export function markClassroomShareConfirmed(): void {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(CLASSROOM_SHARE_CONFIRMED_KEY, "1");
  } catch {
    // Non-critical; the confirm modal may appear again if storage is unavailable.
  }
}
